var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"errorPage"}},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"text top"},[_vm._v(" OOPS! ")]),_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.errorSvg}})]),_c('div',{staticClass:"text bottom"},[_vm._v(" 我们出错了! ")]),_c('router-link',{staticClass:"btn",attrs:{"to":"/"}},[_vm._v(" 再试一次! ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }